/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React from "react";

import { usePlayerCallbacks } from "../../../shared/context/PlayerCallbacksContext";
import { usePlayerComponents } from "../../../shared/context/PlayerComponentsContext";
import { usePlayerTranslation } from "../../../shared/context/PlayerTranslationContext";
import BackIcon from "../../../shared/icons/navigation/Arrow_left.svg";

import "./ClosePlayerButton.scss";

export const ClosePlayerButton = () => {
  const { onClosePlayer } = usePlayerCallbacks();
  const { t } = usePlayerTranslation();
  const { Button } = usePlayerComponents();
  const label = t("PLAYER_TOOLTIP_CLOSE_PLAYER");

  const onClick = () => onClosePlayer?.();

  return (
    <div className="ClosePlayerButtonContainer">
      <Button
        variant="tertiary"
        onClick={onClick}
        tooltip={label}
        tooltipAlign="left"
        tooltipOffset={60}
        aria-label={label}
        iconOnly
      >
        <BackIcon aria-hidden="true" focusable="false" />
      </Button>
    </div>
  );
};
